import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OtpTimerService} from "../../../../core/service/otp-timer-service";
import {TwoFactorCodeRequest} from "../../../../core/requests/TwoFactorRequest";
import {UserAuthenticatedDTO} from "../../../../core/requests/UserAuthenticatedDTO";
import {TwoFactorResendProvider} from "../../../../core/helpers/enums";
import {AuthenticationService} from "../../../../core/service";
import {TranslatePipe} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {maskEmail, maskPhoneNumber} from "../../../../core/helpers/constants";

@Component({
  selector: 'app-login-otp-code',
  templateUrl: './login-otp-code.component.html',
  styleUrls: ['./login-otp-code.component.scss']
})
export class LoginOtpCodeComponent implements OnInit {

  @Input() public hasPhoneNumber: boolean;
  @Input() public user: UserAuthenticatedDTO;
  @Input() public platformUrl: string;
  @Output() onCodeSent = new EventEmitter<string>();
  @Output() close = new EventEmitter();
  selectedOption = 'email';

  constructor(private otpTimerService: OtpTimerService,
              private translate: TranslatePipe,
              private _toastrService: ToastrService,
              private authenticationService: AuthenticationService) {
  }

  ngOnInit(): void {
  }

  closeOtpOptions() {
    this.close.emit();
  }

  resendOtp() {
    const params: TwoFactorCodeRequest = {
      platformUrl: this.platformUrl,
      email: this.user.email,
      tempAuthToken: this.user.temporaryAuthenticationToken,
      resendProvider: this.selectedOption === 'email' ? TwoFactorResendProvider.Email : TwoFactorResendProvider.Phone
    };
    this.authenticationService.resendTwoFactorCode(params).subscribe({
        next: () => {
          this.onResendTwoFactorCodeSuccess();
        },
        error: (error) => {
          this.onResendTwoFactorCodeFail(error);
        }
      }
    );
  }

  get maskedPhone(): string {
    if (!this.user.phoneNumber) return '';
    return maskPhoneNumber(this.user.phoneNumber.replace(/\D/g, ''));
  }

  get maskedEmail(): string {
    return maskEmail(this.user.email);
  }

  private onResendTwoFactorCodeSuccess() {
    this._toastrService.success(
      this.translate.transform('LOGIN.RESEND_OTP_CODE'),
      this.translate.transform('SUCCESS'),
      {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
    );

    this.otpTimerService.startCountdown();
    this.onCodeSent.emit();
  }

  private onResendTwoFactorCodeFail(error: any) {
    error.messages.forEach((errorItem: string) => {
      if(errorItem !== 'RESEND_2FA_TOKEN.TEMP_TOKEN_EXPIRED' && errorItem !== 'RESEND_2FA_TOKEN.INVALID_TEMP_TOKEN') {

      }
    });
    this.onCodeSent.emit(error.messages[0]);
  }
}
